import { Navigate } from 'react-router-dom';

const Redirect = () => <Navigate to='/' />;

export { Redirect };
